/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var View = require('../../view/modal/Confirm');
var Model = nb.define({
    parent: require('./Dialog'),
    method: {
        init: function () {
            this.set('modalName', 'modal-confirm');
            this.onChange('confirm', function () {
                var processor = this.get('processor');
                if (processor && processor.confirm) {
                    var confirm = processor.confirm;
                    confirm.call(processor.scope);
                }
                this.set('hide',new Date());
            }, this);
            this.onChange('cancel', function () {
                var processor = this.get('processor');
                if (processor && processor.cancel) {
                    var cancel = processor.cancel;
                    cancel.call(processor.scope);
                }
                this.set('hide',new Date());
            }, this);
            this.onChange('text', function (inEvent, inText) {
                var text = inText;
                if (typeof text === 'object') {
                    var lang = nb.model.get('switchLanguage');
                    text = text[lang].text
                }
                return text
            }, this, {before: true});
        },
        setData: function () {
            return {
                cn: {
                    title: '提示',
                    cancelBtnText: '取消',
                    confirmBtnText: '确定'
                },
                en: {
                    title: 'Notice',
                    cancelBtnText: 'Cancel',
                    confirmBtnText: 'Confirm'
                }
            }
        }
    }
});
var model = new Model();
var view = new View;
view.setModel(model);
model.onChange('show',function () {
    if(!this._isInit){
        view.$().appendTo(document.body);
        this._isInit = true;
    }
},this,{before:true});
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/Confirm.js
// module id = 17
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34